import { forwardRef } from 'react'
import { FilterButtonProps } from './FilterButton.types'
import { FilterButtonContainer } from './FilterButton.styles'
import FilterActivatorIcon from '@/assets/images/filter-activator-icon.svg?react'
import FilterActivatorIconActive from '@/assets/images/filter-activator-icon-active.svg?react'
import { Circle } from '../../circle/circle.styles'
import Typography from '@/ui/components/typography'
import { useCustomTheme } from '@/core/theme'
import FilterButtonStatus from './FilterButtonStatus'

const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
    (
        {
            label = 'Filter',
            active = false,
            onClick,
            className,
            disabled = false,
            filteredCount,
            totalCount,
            statusLabel,
            emptyStatusText,
            hasActiveFilters = false,
        },
        ref
    ) => {
        const theme = useCustomTheme()
        const isActive = active && hasActiveFilters

        return (
            <FilterButtonContainer
                data-testid="filter-button"
                ref={ref}
                onClick={onClick}
                className={className}
                disabled={disabled}
                aria-pressed={active}
                aria-label={label}
                isActive={isActive}
            >
                {isActive ? (
                    <FilterActivatorIconActive />
                ) : (
                    <FilterActivatorIcon />
                )}
                <Typography variant="s-regular" color={theme.colors.greys[800]}>
                    {label}
                </Typography>
                <Circle width="5px" />
                <FilterButtonStatus
                    filteredCount={filteredCount}
                    totalCount={totalCount}
                    statusLabel={statusLabel}
                    emptyStatusText={emptyStatusText}
                    hasActiveFilters={hasActiveFilters}
                />
            </FilterButtonContainer>
        )
    }
)

FilterButton.displayName = 'FilterButton'

export default FilterButton
